export default ['1P', '3P']
